require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/entries.js
// module id = 227
// module chunks = 0